import React, { useState, useEffect } from 'react';
import { MessageCircle, X, Phone, Copy, Check } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [copied, setCopied] = useState(false);
  
  // WhatsApp number
  const whatsappNumber = '3517858967';
  const whatsappNumberFull = '+39 351 785 8967';
  
  // Show button after scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    
    window.addEventListener('scroll', handleScroll);
    const timer = setTimeout(() => setIsVisible(true), 3000);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);
  
  const copyNumber = () => {
    navigator.clipboard.writeText(whatsappNumberFull);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  
  if (!isVisible) return null;
  
  return (
    <>
      {/* Popup */}
      {showPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" onClick={() => setShowPopup(false)}>
          <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-sm w-full" onClick={e => e.stopPropagation()}>
            <div className="flex justify-between items-start mb-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#25D366] rounded-full flex items-center justify-center">
                  <MessageCircle className="w-6 h-6 text-white fill-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Scrivici su WhatsApp</h3>
                  <p className="text-sm text-gray-500">Risposta rapida garantita</p>
                </div>
              </div>
              <button onClick={() => setShowPopup(false)} className="text-gray-400 hover:text-gray-600">
                <X className="w-5 h-5" />
              </button>
            </div>
            
            {/* Numero */}
            <div className="bg-gray-50 rounded-lg p-4 mb-4">
              <p className="text-sm text-gray-500 mb-1">Il nostro numero WhatsApp:</p>
              <p className="text-xl font-semibold text-gray-900">{whatsappNumberFull}</p>
            </div>
            
            {/* Actions */}
            <div className="space-y-2">
              <a 
                href={`https://wa.me/39${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 w-full bg-[#25D366] hover:bg-[#20BD5A] text-white py-3 px-4 rounded-lg font-medium transition-colors"
              >
                <MessageCircle className="w-5 h-5" />
                Apri WhatsApp
              </a>
              
              <button 
                onClick={copyNumber}
                className="flex items-center justify-center gap-2 w-full bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 px-4 rounded-lg font-medium transition-colors"
              >
                {copied ? <Check className="w-5 h-5 text-green-500" /> : <Copy className="w-5 h-5" />}
                {copied ? 'Copiato!' : 'Copia numero'}
              </button>
              
              <a 
                href={`tel:+39${whatsappNumber}`}
                className="flex items-center justify-center gap-2 w-full border border-gray-200 hover:bg-gray-50 text-gray-700 py-3 px-4 rounded-lg font-medium transition-colors"
              >
                <Phone className="w-5 h-5" />
                Chiama
              </a>
            </div>
          </div>
        </div>
      )}
      
      {/* WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-40">
        <button
          onClick={() => setShowPopup(true)}
          className="group flex items-center justify-center w-16 h-16 bg-[#25D366] rounded-full shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300"
          aria-label="Contattaci su WhatsApp"
          data-testid="whatsapp-button"
        >
          <MessageCircle className="w-8 h-8 text-white fill-white" />
          <span className="absolute w-16 h-16 rounded-full bg-[#25D366] animate-ping opacity-30" />
        </button>
      </div>
    </>
  );
};

export default WhatsAppButton;
